import { AssetType } from 'src/app/models/defines';

export type AssetScope = 'workspace' | 'project' | 'trash';
export type AssetCollection = 'all' | 'recent' | 'generated' | 'used';
export type AssetViewMode = 'grid' | 'details';
export type AssetSortField = 'name' | 'createdAt' | 'modifiedAt' | 'type' | 'size';
export type AssetSortDirection = 'asc' | 'desc';

export interface AssetSort {
    by: AssetSortField;
    direction: AssetSortDirection;
}

export interface AssetLocation {
    scope: AssetScope;
    projectId: string | null;
    collection: AssetCollection;
    folderPath: string[];
    search: string;
    filters: { type: AssetType | null };
    sort: AssetSort;
    viewMode: AssetViewMode;
}

export interface AssetBrowserQuery {
    scope: AssetScope;
    projectId: string | null;
    collection: AssetCollection;
    folderPath: string[];
    search: string;
    filters: { type: AssetType | null };
    sort: AssetSort;
    cursor?: string;
    limit?: number;
}

export const DEFAULT_ASSET_LOCATION: AssetLocation = {
    scope: 'workspace',
    projectId: null,
    collection: 'all',
    folderPath: [],
    search: '',
    filters: { type: null },
    sort: { by: 'createdAt', direction: 'desc' },
    viewMode: 'grid',
};
